module.exports = __webpack_public_path__ + "static/media/heart.5139486a.svg";